import { defineNamespace, type FlowT } from "../../i18n/define-namespace";
import { WGL_SUPPORT_PHONE } from "../constants";
import en from "./en.json";
import es from "./es.json";

/**
 * WGL tenant-level strings (error / not-found pages). Registered at module
 * scope: Next evaluates the i18n registry separately in the RSC and client
 * graphs, so every consumer — `use-t.ts` and `server.ts` — imports this
 * module and the bundle lands in whichever graph is rendering.
 */
export const wglNamespace = defineNamespace({
  ns: "wgl",
  en,
  es,
  defaults: { phone: WGL_SUPPORT_PHONE },
});
wglNamespace.register();

export type WglT = FlowT<typeof en>;
